import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	componentLabel: {
		id: 'issue-field-components-field.edit.menu.component-label',
		defaultMessage: 'Create new component',
		description: 'Component label. Allows to create new components from dropdown link.',
	},
});
